import React from 'react';
import SectionHeader from './SectionHeader';
import CurrencyInput from './CurrencyInput';
import NotesInput from './NotesInput';

/**
 * Section 10 — Pets
 */
export default function StepPets({ data = {}, onChange }) {
  function set(field, value) {
    onChange({ ...data, [field]: value });
  }

  const fields = [
    { key: 'food_supplies', label: 'Food & Supplies' },
    { key: 'grooming', label: 'Grooming' },
    { key: 'boarding_pet_sitting', label: 'Boarding / Pet Sitting Fees' },
    { key: 'vet', label: 'Vet' },
    { key: 'other_pet_expenses', label: 'Other Pet Expenses' },
  ];

  const total = fields.reduce(
    (sum, f) => sum + (Number(data[f.key]) || 0),
    0
  );

  return (
    <div>
      <SectionHeader
        number={10}
        title="Pets"
        tip="No furry, feathered, finned, or scaled friends? Just click Nothing to enter to skip."
      />

      <div className="cashflow-field-grid">
        {fields.map(({ key, label }) => (
          <CurrencyInput
            key={key}
            id={key}
            label={label}
            value={data[key] ?? null}
            onChange={(val) => set(key, val)}
          />
        ))}
      </div>

      {total > 0 && (
        <div className="cashflow-total-box mt-3">
          <span className="fw-semibold">13: Total Pet Expenses</span>
          <span className="cashflow-total-amount">
            ${total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
        </div>
      )}

      <NotesInput value={data.notes} onChange={(val) => set('notes', val)} />
    </div>
  );
}
